import type { IUseCase } from 'shared-kernel';
import type { IUserAdminRepository } from '../../domain/ports';

export interface DeverrouillerCompteInput {
  idUtilisateur: string;
}

export class DeverrouillerCompteUseCase implements IUseCase<DeverrouillerCompteInput, void> {
  constructor(private readonly repository: IUserAdminRepository) {}

  async execute(input: DeverrouillerCompteInput): Promise<void> {
    const response = await this.repository.deverrouillerCompte(input.idUtilisateur);

    if (!response.succes) {
      throw new Error(response.message || 'Erreur lors du deverrouillage');
    }
  }
}
